<template>
	<el-dialog
	  title="绑定微信"
	  :visible.sync="dialogVisible"
	  width="30%" append-to-body>
	   <div class="login">
		   <div class="qrcode-wrapper">
			   <div class="qrcode-container" v-loading="loading" id="qrcode" ref="qrCodeUrl">
				 <!--  <img :src="loginurl" alt=""> -->

				  <wxlogin
				   href='data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7CiAgICB3aWR0aDogMjAwcHg7Cn0KLmltcG93ZXJCb3ggLnRpdGxlIHsKICAgIHRleHQtYWxpZ246IGxlZnQ7CiAgICBmb250LXNpemU6IDE2cHg7CiAgICBmb250LXdlaWdodDogYm9sZDsKICAgZGlzcGxheTpub25lOwp9'
				   id="wxcode"
				   theme=''
				   appid="wxe0faa9f11675abae"
				   scope="snsapi_userinfo"
				   style="margin-top: 10px;display: none;"
				   :redirect_uri="encodeURIComponent(redirect_uri)"></wxlogin>
			   </div>

		   </div>
		   <div style="width: 100%;text-align: center;">请使用微信扫码绑定</div>
	   </div>
	</el-dialog>
</template>

<script>
	import wxlogin from 'vue-wxlogin';
	import QRCode from 'qrcodejs2'
  import {mapGetters} from "vuex"
	export default {
		components:{
			wxlogin
		},
    computed:{
      ...mapGetters(["userinfo"]),
    },
		data(){
			return{
				loading:false,
				dialogVisible:false,
				redirect_uri: "https://www.qichengzhiyuan.cn/#" + this.$route.path,
				loginurl:'',
				timer:null,
			}
		},
		watch:{
			dialogVisible(e){
				if(e==false){
					clearInterval(this.timer)
					//清除二维码
					const codeHtml = document.getElementById("qrcode");
					codeHtml.innerHTML = "";
				}
			},
		},
		methods:{
			show(type){
				this.dialogVisible = true
				console.log("login5")
        this.$store.dispatch("getUserInfo").then(()=>{
          let that = this;
          let url = encodeURIComponent("https://www.qichengzhiyuan.cn/#" + this.$route.fullPath);
          let uid = new Date().getTime() +Math.ceil(Math.random()*10);
          this.$nextTick(()=>{
          	new QRCode('qrcode', {
          		text: "https://www.qichengzhiyuan.cn/api/MemberUser/jiutian_login?memberuser_id=" + this.userinfo.memberuser_id, // 需要转换为二维码的内容
          		width: 240,
          		height: 240,
          		colorDark: '#000000',
          		colorLight: '#ffffff',
          		correctLevel: QRCode.CorrectLevel.H
          	})
          	//此时进行轮训
          	that.timer =  setInterval(()=>{
				console.log("login6")
              this.$store.dispatch("getUserInfo").then(res=>{
                 if(res.openid){
                   clearInterval(that.timer);
                   this.$message.success("绑定成功");
                   this.dialogVisible = false
                 }
              })
          	},1000)
        })
				})
			},
			hide(){
				this.dialogVisible = false
				clearInterval(this.timer)
			},
		}
	}
</script>

<style lang="scss" scoped>
	// .qrcode-container{
	// 	margin-top: 150px;
	// }
	.login{
		width: 300px;
		margin: 0 auto;
		// margin-top: 10px;
		padding-bottom: 30px;
		.weixin-login-tips{
			    font-size: 14px;
			    color: rgba(0,0,0,.8);
				width: 100%;
				margin-top: 20px;
				text-align: center;
		}
		.qrcode-wrapper{
			width: 204px;
			height: 204px;
			background: #fff;
			// border: 1px solid #eee;
			border-radius: 6px;
			margin: 24px auto;
			display: flex;
			align-items: center;
			justify-content: center;
			.qrcode-container{
				position: relative;
				width: 100%;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				img{
					width: 250px;
					height: 250px;
				}
			}
		}
		.weixin-login-title{
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 20px;
			color: rgba(0,0,0,.8);
			width: 100%;
			i{
				display: inline-block;
				width: 26px;
				height: 26px;
				background-image: url(../assets/svg/logreg_sprite.svg);
				background-position: -29px -28px;
				margin-right: 10px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/wxlogin.vue